/* ============================================================
   thesis® cart controller — standalone
   Drives sections/thesis-cart-drawer.liquid (#sidebar-cart)
   Public API (used by PDP, New Layers, Edition, quick cards):
     ThesisCart.open() / close() / refresh() / refreshAndOpen()
     ThesisCart.change(line, quantity) / setOpenState(bool)
   The drawer starts sliding immediately; only the inner content
   is swapped when fresh cart HTML arrives, so motion never jumps.
============================================================ */
(function () {
  var ThesisCart = window.ThesisCart = window.ThesisCart || {};
  if (ThesisCart.__standalone) return;
  ThesisCart.__standalone = true;

  var SECTION_ID = 'thesis-cart-drawer';
  var lastFocus = null;
  var pending = null;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function drawer() {
    return document.getElementById('sidebar-cart');
  }

  function unlockIfIdle() {
    if (!document.querySelector('#sidebar-menu.is-open, [data-thesis-search].is-open, #sidebar-cart.is-open')) {
      document.documentElement.classList.remove('thesis-lock');
    }
  }

  function updateCount(count) {
    if (typeof count !== 'number' || isNaN(count)) return;
    document.querySelectorAll('[data-thesis-cart-count]').forEach(function (node) { node.textContent = count; });
    document.querySelectorAll('[data-thesis-cart-dot]').forEach(function (node) { node.classList.toggle('is-visible', count > 0); });
  }

  ThesisCart.setOpenState = function (isOpen) {
    document.body.classList.toggle('thesis-cart-is-open', Boolean(isOpen));
  };

  ThesisCart.open = function () {
    var el = drawer();
    if (!el) { window.location.href = rootUrl() + 'cart'; return; }
    if (el.classList.contains('is-open')) return;
    document.dispatchEvent(new CustomEvent('thesis:menu:close'));
    lastFocus = document.activeElement;
    document.documentElement.classList.add('thesis-lock');
    ThesisCart.setOpenState(true);
    el.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      el.classList.add('is-open');
      setTimeout(function () {
        var panel = el.querySelector('.tc__panel');
        if (panel) panel.focus({ preventScroll: true });
      }, 520);
    });
  };

  ThesisCart.close = function () {
    var el = drawer();
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    ThesisCart.setOpenState(false);
    unlockIfIdle();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };

  ThesisCart.refresh = function () {
    if (pending) return pending;
    pending = fetch(rootUrl() + '?sections=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var html = data && data[SECTION_ID];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-thesis-cart-content]');
        var el = drawer();
        var current = el && el.querySelector('[data-thesis-cart-content]');
        if (fresh && current) current.replaceWith(fresh);
        if (fresh) updateCount(Number(fresh.getAttribute('data-thesis-cart-item-count')));
      })
      .then(function () { pending = null; }, function (error) { pending = null; throw error; });
    return pending;
  };

  ThesisCart.refreshAndOpen = function () {
    var el = drawer();
    if (el) el.classList.add('is-loading');
    ThesisCart.open();
    return ThesisCart.refresh()
      .catch(function (error) { console.warn('thesis cart refresh failed', error); })
      .then(function () {
        var current = drawer();
        if (current) current.classList.remove('is-loading');
      });
  };

  ThesisCart.change = function (line, quantity) {
    var el = drawer();
    if (el) el.classList.add('is-loading');
    return fetch(rootUrl() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) })
    })
      .then(function () { return ThesisCart.refresh(); })
      .catch(function (error) { console.warn('thesis cart change failed', error); })
      .then(function () {
        var current = drawer();
        if (current) current.classList.remove('is-loading');
      });
  };

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-thesis-cart-open]');
    if (opener) {
      if (document.body.classList.contains('template-cart')) return;
      event.preventDefault();
      ThesisCart.refreshAndOpen();
      return;
    }

    if (event.target.closest('[data-thesis-cart-close]')) {
      event.preventDefault();
      ThesisCart.close();
      return;
    }

    var qty = event.target.closest('[data-thesis-qty]');
    if (qty) {
      var line = qty.closest('[data-line]');
      if (line) {
        event.preventDefault();
        ThesisCart.change(line.getAttribute('data-line'), qty.getAttribute('data-thesis-qty'));
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') ThesisCart.close();
  });

  /* Global quick add — used by product cards / modules with [data-thesis-quick-add] */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-thesis-quick-add]');
    if (!button) return;
    event.preventDefault();
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Shopify rejected add to cart: ' + response.status);
        button.classList.add('is-added');
        return ThesisCart.refreshAndOpen();
      })
      .then(function () {
        setTimeout(function () { button.classList.remove('is-added'); }, 1400);
      })
      .catch(function (error) {
        console.warn('thesis quick add failed', error);
        button.classList.add('is-error');
        setTimeout(function () { button.classList.remove('is-error'); }, 1400);
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.setAttribute('aria-busy', 'false');
      });
  });

  /* Warm the cart section once the page is idle so the first open is instant. */
  var warm = function () { ThesisCart.refresh().catch(function () {}); };
  if ('requestIdleCallback' in window) { requestIdleCallback(warm, { timeout: 3000 }); } else { setTimeout(warm, 2000); }

  document.addEventListener('shopify:section:select', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('#sidebar-cart')) ThesisCart.open();
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('#sidebar-cart')) ThesisCart.close();
  });
})();
